import React, { useState } from "react";
import TweetBox from "./feed/feed";
import Header from "./Header/header";
import  "./home.css";
import {Alert} from "react-bootstrap";
function Home({ isDarkMode, toggleTheme }) {
    return (
        <div className="home">
            <TweetBox isDarkMode={isDarkMode} toggleTheme={toggleTheme} />
        </div>
    );
}

export default Home;
